import { createReducer } from '@reduxjs/toolkit';
import * as actions from './actions';
import { EobDocumentsState, EobDownloadsState } from './types';

export const eobDocumentsReducerInitialState = (): EobDocumentsState => ({
  isFetching: false,
  error: null,
  data: null
});

export const eobDocumentsReducer = createReducer(eobDocumentsReducerInitialState(), {
  [actions.GET_EOB_DOCUMENTS]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.GET_EOB_DOCUMENTS_SUCCESS]: (state, action) => {
    if (state) state.isFetching = false;
    state.data = {
      content: action.payload.data,
      contentType: 'application/pdf'
    };
  },
  [actions.GET_EOB_DOCUMENTS_FAIL]: (state, action) => {
    state.isFetching = false;
    state.data = null;
    state.error = action.error;
  }
});

export const eobDownloadsInitialState = (): EobDownloadsState => ({
  isDownloading: false,
  error: null
});

export const eobDownloadsReducer = createReducer(eobDownloadsInitialState(), {
  [actions.DOWNLOAD_EOB]: state => {
    state.isDownloading = true;
    state.error = null;
  },
  [actions.DOWNLOAD_EOB_SUCCESS]: state => {
    state.isDownloading = false;
  },
  [actions.DOWNLOAD_EOB_FAIL]: (state, action) => {
    state.isDownloading = false;
    state.error = action.error;
  }
});
